import { render } from "./judgement-count.vue?vue&type=template&id=3bd5330b&scoped=true"
import script from "./judgement-count.vue?vue&type=script&lang=js"
export * from "./judgement-count.vue?vue&type=script&lang=js"

import "./judgement-count.vue?vue&type=style&index=0&id=3bd5330b&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd5330b"]])

export default __exports__